import React from "react";
import styled from "styled-components";
import ProductDetailsTable from "components/widgets/ProductDetailsTable";
import Config from "components/widgets/config";
// Styled Components
const Container = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Section = styled.div`
  margin-bottom: 48px;
`;

const Title = styled.h2`
  font-size: 20px;
  margin-bottom: 12px;
  color: #555;
`;

// Main Page Component
export default function ProductDetailsPage() {
  return (
    <Container>
      <h1>Product Details</h1>

      {/* Table Section */}
      <Section>
        <ProductDetailsTable />
      </Section>

      {/* Configuration Section */}
      <Section>
        <Title>Product Configuration</Title>
        <Config/>
      </Section>
    </Container>
  );
}
